export default __webpack_public_path__ + "static/media/62t.a2be0de4.jpg";